 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab":"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab","archived":"archived","cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18":"cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18","cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b":"cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b","cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover":"cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover","cards":"cards","chart":"chart","compare-headline":"compare-headline","compare-party":"compare-party","generic":"generic","headline":"headline","milestone":"milestone","rollcall":"rollcall","text":"text","event~granissat-event~granissat-speakers~speakers":"event~granissat-event~granissat-speakers~speakers","event":"event","granissat-event":"granissat-event","media":"media","quote":"quote","tweet":"tweet","granissat-speakers":"granissat-speakers","speakers":"speakers","fakenews":"fakenews","granissat-generic":"granissat-generic","granissat-headline":"granissat-headline","granissat-proposal":"granissat-proposal","granissat-quote":"granissat-quote","granissat-text":"granissat-text","igualtat":"igualtat","ivace":"ivace","labora":"labora","resisteix":"resisteix","videocover":"videocover","christmas":"christmas","christmas-2021":"christmas-2021","granissat-cover":"granissat-cover","social":"social","sumar-generic":"sumar-generic","sumar-speakers":"sumar-speakers"}[chunkId]||chunkId) + "." + {"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab":"4774cf30","archived":"1b7f55f8","cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18":"fc056242","cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b":"15aa9527","cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover":"1d988fd2","cards":"d2a7df6a","chart":"9060b987","compare-headline":"acaa1dc8","compare-party":"9911c5a4","generic":"a2d9409c","headline":"b3cad912","milestone":"754ed44e","rollcall":"ea892766","text":"140e0740","event~granissat-event~granissat-speakers~speakers":"a5c60556","event":"604735c9","granissat-event":"f3e4bad0","media":"9cbfd94d","quote":"93945df5","tweet":"17af1457","granissat-speakers":"7e4009a4","speakers":"fb72fdd6","fakenews":"c4c91e4a","granissat-generic":"dc2368e8","granissat-headline":"3bfe83f8","granissat-proposal":"fffe8225","granissat-quote":"3d06a5c4","granissat-text":"2e2bede3","igualtat":"ebef7c26","ivace":"297f1bf4","labora":"bd814ba4","resisteix":"438513a7","videocover":"acd6538f","christmas":"8cbcdf93","christmas-2021":"ec816a91","granissat-cover":"f60266f5","social":"b2fa012d","sumar-generic":"06a02934","sumar-speakers":"0c378781","chunk-254d8160":"784c9917","chunk-e5abddae":"927a0814"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab":1,"archived":1,"cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18":1,"cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b":1,"cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover":1,"cards":1,"chart":1,"compare-headline":1,"compare-party":1,"generic":1,"headline":1,"milestone":1,"rollcall":1,"text":1,"event~granissat-event~granissat-speakers~speakers":1,"event":1,"granissat-event":1,"media":1,"quote":1,"tweet":1,"granissat-speakers":1,"speakers":1,"fakenews":1,"granissat-generic":1,"granissat-headline":1,"granissat-proposal":1,"granissat-quote":1,"granissat-text":1,"igualtat":1,"ivace":1,"labora":1,"resisteix":1,"videocover":1,"christmas":1,"christmas-2021":1,"granissat-cover":1,"social":1,"sumar-generic":1,"sumar-speakers":1,"chunk-254d8160":1,"chunk-e5abddae":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab":"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab","archived":"archived","cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18":"cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18","cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b":"cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b","cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover":"cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover","cards":"cards","chart":"chart","compare-headline":"compare-headline","compare-party":"compare-party","generic":"generic","headline":"headline","milestone":"milestone","rollcall":"rollcall","text":"text","event~granissat-event~granissat-speakers~speakers":"event~granissat-event~granissat-speakers~speakers","event":"event","granissat-event":"granissat-event","media":"media","quote":"quote","tweet":"tweet","granissat-speakers":"granissat-speakers","speakers":"speakers","fakenews":"fakenews","granissat-generic":"granissat-generic","granissat-headline":"granissat-headline","granissat-proposal":"granissat-proposal","granissat-quote":"granissat-quote","granissat-text":"granissat-text","igualtat":"igualtat","ivace":"ivace","labora":"labora","resisteix":"resisteix","videocover":"videocover","christmas":"christmas","christmas-2021":"christmas-2021","granissat-cover":"granissat-cover","social":"social","sumar-generic":"sumar-generic","sumar-speakers":"sumar-speakers"}[chunkId]||chunkId) + "." + {"archived~cards~chart~christmas~christmas-2021~compare-headline~compare-party~event~fakenews~generic~~53cc17ab":"cfed0fb5","archived":"7f108b96","cards~chart~compare-headline~compare-party~event~fakenews~generic~granissat-event~granissat-generic~~666d0b18":"12a5eb4f","cards~chart~compare-headline~compare-party~event~generic~granissat-event~headline~media~milestone~qu~1313f00b":"1d2c86b9","cards~chart~compare-headline~compare-party~generic~headline~milestone~rollcall~text~videocover":"4abe4d8c","cards":"048ebebb","chart":"11254401","compare-headline":"5626c73b","compare-party":"acfb9d3b","generic":"6935305e","headline":"4960867a","milestone":"0de7b809","rollcall":"3adb1098","text":"2fa3c5c9","event~granissat-event~granissat-speakers~speakers":"2ecb2513","event":"e398a9ee","granissat-event":"80c98f04","media":"cd1c0272","quote":"14097854","tweet":"ac2cb32b","granissat-speakers":"21a8d12a","speakers":"dd63ec81","fakenews":"b5757f7d","granissat-generic":"8bf30913","granissat-headline":"02f15fd7","granissat-proposal":"c1c61122","granissat-quote":"bc6c29dc","granissat-text":"593ec42e","igualtat":"861802ce","ivace":"3764f341","labora":"c8fe4722","resisteix":"86526bb2","videocover":"06abac51","christmas":"a9b6bebd","christmas-2021":"62a70d96","granissat-cover":"12517ff5","social":"be8b3c10","sumar-generic":"ad1c232e","sumar-speakers":"0b0137d1","chunk-254d8160":"11a8c254","chunk-e5abddae":"01d63eca"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
